var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('BJ'),_c('div',{staticClass:"left",staticStyle:{"float":"left"}},[_c('ONE')],1),_c('div',{staticClass:"middle"},[_c('MIDDLE')],1),_c('div',{staticClass:"right",staticStyle:{"float":"right"}},[_c('TWO')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }